import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
// import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../../store/actions/index";
import HorizontalScroll from "../HorizontalScroll/HorizontalScroll";
import classes from "./Workouts.module.css";
import { string_to_slug as slug } from "../../../../store/utility";

class Workouts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.plan.id,
      title: this.props.plan.title,
      categoryName: this.props.categoryName,
      desc: this.props.plan.desc,
      addworkout:{
        title:"",
        url:"",
        planid:""

      }

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleEditPlan = this.handleEditPlan.bind(this);
    this.handleDeletePlan = this.handleDeletePlan.bind(this);
  }

  handleChange(e) {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleEditPlan(e, id) {
    e.preventDefault();
    let editedPlan = {
      id: id,
      title: this.state.title,
      categoryName: this.state.categoryName,
      desc: this.state.desc,
    };
    // console.log(editedPlan, this.props.plan);
    this.props.onEditPlan(editedPlan, this.props.workouts);
  }

  handleDeletePlan(e, id) {
    e.preventDefault();
    // console.log(id);
    this.props.onDeletePlan(id);
  }

  handleWorkoutChange = (e)=>{
    let {name, value} = e.target
    this.setState({
      addworkout:{
      ...this.state.addworkout,
      planid:this.props.plan.id,
      [name]:value
    
    }})
  } 
  handleAddWorkout = (e)=>{
    e.preventDefault();
    let plan = this.props.plan;

    this.props.onAddWorkout(this.state.addworkout,plan)
  }
  render() {
    var plan = this.props.plan;
    return (
      <div className={`container ${classes.HorizontalCarousel}`}>
        <>
          <div className={classes.ItemContainer}>
            <div className={classes.Item}>
              <div className="d-flex">
                <div style={{maxHeight:"188px", overflow:"hidden"}}>
                  <h5>{plan.title}</h5>
                  <p>{plan.desc}</p>
                </div>
 
                <div>
                 
            <div class="form-group col-md-1">
             
              <button
                className="btn btn-success btn-sm "
                data-toggle="modal"
                data-target={`#addWorkout${plan.id}`}

              >
                Add Workout
              </button>
              {/* --------------------------- Add workout plan Modal Starts -------------------------------- */}
              <div
                className="modal fade bd-example-modal-lg "
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                id={`addWorkout${plan.id}`}
              >
                <div
                  className="modal-dialog modal-lg"
                  style={{ overflowY: "initial !important" }}
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLongTitle">
                        Add Workout
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div
                      className="modal-body"
                      style={{
                        // height: "75vh",
                        overflowY: "auto",
                      }}
                    >
                      <form>
                        <div className="form-row">
                          <div className="form-group col-md-4">
                            <label htmlFor="title1">Youtube Title</label>
                            <input
                              type="text"
                              name="title"
                              className="form-control"
                              id="title1"
                              placeholder="Enter Youtube Title"
                              onChange={this.handleWorkoutChange}
                              value={this.state.addworkout.title}
                              required
                            />
                          </div>
                          <div className="form-group col-md-8">
                            <label htmlFor="url">Youtube Url</label>
                            <input
                              type="text"
                              name="url"
                              className="form-control"
                              id="url"
                              placeholder="Enter Youtube Url"
                              onChange={this.handleWorkoutChange}
                              value={this.state.addworkout.url}
                              required
                            />
                          </div>
                        </div> 
                        <div className="text-center">
                          <button
                            type="button"
                            className="btn btn-primary my-1"
                            onClick={this.handleAddWorkout}
                            disabled={this.props.addWorkoutLoading}

                          >
                            {this.props.addWorkoutLoading?"Saving":"Save"}
                          </button>
                        </div>
                       
                      </form>
                      <hr />
                      {/* <div className="row m-2">
                        {this.state.workoutPlan.workouts &&
                          this.state.workoutPlan.workouts.map(
                            (workout, index) => (
                              <div className="card col-sm-12 mt-2" key={index}>
                                <div className="card-body p-1">
                                  <p>
                                    <b> YT title: </b>
                                    {workout.title}
                                  </p>
                                  <p>
                                    <b>YT Url:</b> {workout.url}
                                  </p>
                                  <button
                                    className="btn btn-primary float-right m-2"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                    }}
                                    onClick={(e) =>
                                      this.handleRemove(e, workout)
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            )
                          )}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* --------------------------- Add workout plan Modal Ends -------------------------------- */}
            </div>

                </div>

              </div> 
              



            
              <div>
                {/* <a
                  style={{ color: "#FF8D1E" }}
                  target="_blank"
                  href={`/workouts/${slug(plan.title)}/${plan.id}`}
                >
                  See All
                </a> */}
                <div>
                  <button
                    className="btn btn-primary btn-sm m-2"
                    data-toggle="modal"
                    data-target={`#edit${plan.id}`}
                  >
                    Edit
                  </button>
                  {/* ------------------------------------ Edit Plan Modal starts ------------------------------------*/}
                  <div
                    className="modal fade"
                    id={`edit${plan.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Editing: <b>{plan.title}</b>
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="form-group">
                            <label htmlFor="title" className="col-form-label">
                              Title:
                            </label>
                            <input
                              name="title"
                              type="text"
                              className="form-control"
                              id="title"
                              value={this.state.title}
                              onChange={this.handleChange}
                            />
                          </div>
                          {/* <div class="form-group">
                            <label for="inlineFormSelCategory">Category</label>
                            <select
                              name="categoryName"
                              className="custom-select my-1 mr-sm-2"
                              id="inlineFormSelCategory"
                              value={this.state.categoryName}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="">Select...</option>
                              {this.props.categories &&
                                this.props.categories.map((category, index) => (
                                  <option
                                    key={index}
                                    value={category.categoryName}
                                    // value={this.state.categoryName}
                                  >
                                    {category.categoryName}
                                  </option>
                                ))}
                            </select>
                          </div> */}
                          <div className="form-group">
                            <label htmlFor="title" className="col-form-label">
                              Description:
                            </label>
                            <textarea
                              name="desc"
                              type="text"
                              className="form-control"
                              id="desc"
                              value={this.state.desc}
                              onChange={this.handleChange}
                              rows="3"
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={(e) => this.handleEditPlan(e, plan.id)}
                            disabled={this.props.editBtnLoading}
                          >
                            {this.props.editBtnLoading ? "Saving" : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ------------------------------------ Edit Plan Modal ends ------------------------------------*/}
                  <button
                    className="btn btn-primary btn-sm m-2"
                    data-toggle="modal"
                    data-target={`#delete${plan.id}`}
                  >
                    Delete
                  </button>
                  {/* ------------------------------------ Delete Plan Modal starts ------------------------------------*/}
                  <div
                    className="modal fade"
                    id={`delete${plan.id}`}
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exampleModalLabel">
                            Irreversible Operation
                          </h5>
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <p>
                            Are you sure you want to delete <b>{plan.title}</b>
                          </p>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={(e) => this.handleDeletePlan(e, plan.id)}
                            disabled={this.props.deleteBtnLoading}
                          >
                            {this.props.deleteBtnLoading
                              ? "Deleting"
                              : "Delete"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ------------------------------------ Delete Plan Modal ends ------------------------------------*/}
                
                  <div>
                      <a style={{color:"#FF8D1E"}} target="_blank" href={`/admin/workouts/${slug(plan.title)}/${plan.id}`} >See All</a>
                  </div>
                
                </div>
              </div>
            </div> 
          </div>

         <HorizontalScroll plan={plan} index={this.props.index} />
        </>
      </div> 
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.category.categories,
    workouts: state.workouts.workouts,
    editBtnLoading: state.workouts.editBtnLoading,
    deleteBtnLoading: state.workouts.deleteBtnLoading,
    addWorkoutLoading:state.workouts.addWorkoutLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onEditPlan: (editedPlan, actualPlan) =>
      dispatch(actions.onEditPlan(editedPlan, actualPlan)),
    onDeletePlan: (id) => dispatch(actions.onDeletePlan(id)),
    // onFetchCategory: () => dispatch(actions.fetchCategoryAdmin()),
    onAddWorkout:(workout,plan)=>dispatch(actions.onAddWorkout(workout,plan))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Workouts, Axios));
